<ng-container *ngIf="wizard">
  <div *ngIf="showCustomerCreate || customerList?.length == 0">
    <div class="card bg-secondary ml-0 mr-0 p-2 mb-3">
      <div class="row">
        <div class="col-auto">
          <span class="material-icons pl-2 lh-30 align-middle">
            help_outline
          </span>
        </div>
        <div class="col-10">
          <p class="mb-0 lh-30 align-middle">
            {{ "orgprojectadd.customercreationhelp" | trans }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!showCustomerCreate && customerList?.length != 0">
    <form name="projectcreate">
      <div class="form-group">
        <p class="mb-0 cursor-pointer">
          {{ "orgprojectadd.projecttitle" | trans }}
        </p>
        <input
          id="projecttitle"
          [readonly]="step == 1 ? null : 'true'"
          class="form-control"
          type="text"
          name="title "
          placeholder="{{ 'orgprojectadd.projecttitleplace' | trans }}"
          [(ngModel)]="project.title"
          required
        />
      </div>
      <div class="form-group">
        <p class="mb-0 cursor-pointer"></p>
        <textarea
          id="projectdescription"
          [readonly]="step == 1 ? null : 'true'"
          class="form-control"
          type="text"
          placeholder="{{ 'orgprojectadd.descriptionplace' | trans }}"
          name="projectdescription"
          [(ngModel)]="project.projectdescription"
          required
        ></textarea>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.startdate" | trans }}
            </p>
            <input
              id="startdate"
              [readonly]="step == 1 ? null : 'true'"
              type="date"
              class="form-control"
              name="startdate"
              [ngModel]="project.start_date | date: 'yyyy-MM-dd'"
              (ngModelChange)="project.start_date = $event"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.enddate" | trans }}
            </p>
            <input
              id="enddate"
              [readonly]="step == 1 ? null : 'true'"
              type="date"
              class="form-control"
              name="enddate"
              [ngModel]="project.end_date | date: 'yyyy-MM-dd'"
              (ngModelChange)="project.end_date = $event"
              required
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <p class="mb-0 cursor-pointer" >
              {{ "orgprojectadd.workloadfte" | trans }}
            </p>
              <input
                type="number"
                min="0"
                step="0.1"
                class="form-control"
                name="workload_fte"
                placeholder="1.0"
                [(ngModel)]="project.workload_fte"
              />
              </div>
            </div>
          </div>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.customer" | trans }}
            </p>
            <select
              (change)="setCustomer(project.customer)"
              [disabled]="step == 1 ? null : 'true'"
              id="addcustomerchoise"
              name="customer"
              [(ngModel)]="project.customer"
              class="form-control"
              required
            >
              <option
                *ngIf="!project.customer"
                style="visibility: hidden !important; display: none"
                [ngValue]="null"
                selected
              >
                {{ "orgprojectadd.choose" | trans }}
              </option>
              <option
                *ngFor="let customer of customerList"
                [ngValue]="customer.customerId"
              >
                {{ customer.title }}
              </option>
            </select>
          </div>
          <div
            *ngIf="project.customer && dealList && dealList.length > 0"
            class="form-group"
          >
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.deal" | trans }}
            </p>
            <select
              [disabled]="step == 1 ? null : 'true'"
              id="addcustomerdealchoise"
              name="deal"
              [(ngModel)]="project.dealId"
              class="form-control"
            >
              <option
                *ngIf="!project.dealId"
                style="visibility: hidden !important; display: none"
                [ngValue]="null"
                selected
              >
                {{ "orgprojectadd.choose" | trans }}
              </option>
              <option *ngFor="let deal of dealList" [ngValue]="deal.dealId">
                {{ deal.dealname }}
              </option>
            </select>
          </div>
        </div>

        <!----<div class="col-auto pl-0">
          <button class="border-0 bg-transparent" type="button" (click)="openCreateCustomer()" >
            <span  class="material-icons portal-icon align-middle lh-35 center btn  p-0 rounded-circle mt-3 w-35 h-35">
                add
            </span>
        </button>

        </div>--->
      </div>
      <div *ngIf="errorMessage != null" class="alert alert-danger ml-0 mr-0">
        <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
      </div>
    </form>

    <div class="row">
      <!-- <div class="col">
          <button type="button" class="close" (click)="openCreateCustomer()" class="btn w-100 float-left"><h6 class="btn-text">Create new customer</h6></button>
         </div> -->
      <div class="col">
        <button
          id="createproject"
          type="button"
          class="close"
          (click)="createProject()"
          class="btn w-100 float-left"
        >
          <h6 class="btn-text">{{ "orgprojectadd.createproject" | trans }}</h6>
        </button>
      </div>
      <!----<div class="col">
          <button id="createprojectanda" *ngIf="step == 1" (click)="createProject()" class="btn-save float-right" type="submit"><h6 class="btn-save-text">{{ 'orgprojectadd.createandassign' | trans }}</h6></button>
            <button *ngIf="step == 2" (click)="ngOnInit()" data-dismiss="modal" class="btn-close float-right" type="submit"><h6 class="btn-save-text">{{ 'orgprojectadd.close' | trans }}</h6></button>
         </div>--->
    </div>
  </div>
  <app-customercreate
    *ngIf="showCustomerCreate || customerList?.length == 0"
    [fromproject]="true"
    (customerToAdd)="addCustomer($event)"
  ></app-customercreate>
</ng-container>

<div class="modal-dialog modal-dialog-centered modal-lg" *ngIf="!wizard">
  <div class="modal-content">
    <div class="modal-header">
      <h6
        *ngIf="!showCustomerCreate && customerList?.length != 0"
        class="modal-title"
      >
        {{ "orgprojectadd.createyourproject" | trans }}
      </h6>
      <h6
        *ngIf="showCustomerCreate || customerList?.length == 0"
        class="modal-title"
      >
        {{ "orgprojectadd.createyourcustomer" | trans }}
      </h6>
      <button
        #projectmodalclose
        type="button"
        class="close"
        data-dismiss="modal"
        (click)="closeModal()"
      >
        &times;
      </button>
    </div>
    <div class="modal-body">
      <div *ngIf="customerList?.length == 0">
        <div class="card bg-secondary ml-0 mr-0 p-2 mb-3">
          <div class="row">
            <div class="col-auto">
              <span class="material-icons pl-2"> help_outline </span>
            </div>
            <div class="col-10">
              <p class="mb-0">
                {{ "orgprojectadd.customercreationhelp" | trans }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!showCustomerCreate && customerList?.length != 0">
        <form name="projectcreate">
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.projecttitleplace" | trans }}
            </p>
            <input
              [readonly]="step == 1 ? null : 'true'"
              class="form-control"
              type="text"
              name="title "
              placeholder="{{ 'orgprojectadd.projecttitleplace' | trans }}"
              [(ngModel)]="project.title"
            />
          </div>
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.description" | trans }}
            </p>
            <textarea
              [readonly]="step == 1 ? null : 'true'"
              class="form-control"
              type="text"
              placeholder="{{ 'orgprojectadd.descriptionplace' | trans }}"
              name="projectdescription"
              [(ngModel)]="project.projectdescription"
            ></textarea>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <p class="mb-0 cursor-pointer">
                  {{ "orgprojectadd.startdate" | trans }}
                </p>
                <input
                  [readonly]="step == 1 ? null : 'true'"
                  type="date"
                  class="form-control"
                  name="startdate"
                  [(ngModel)]="project.start_date"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <p class="mb-0 cursor-pointer">
                  {{ "orgprojectadd.enddate" | trans }}
                </p>
                <input
                  [readonly]="step == 1 ? null : 'true'"
                  type="date"
                  class="form-control"
                  name="enddate"
                  [(ngModel)]="project.end_date"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <h6
                  class="h6 h6_custom_sm cursor-pointer header-custom projectheader"
                >
                  Workload FTE
                </h6>
                <input
                  type="number"
                  min="0"
                  step="0.1"
                  class="form-control"
                  name="workload_fte"
                  placeholder="1.0"
                  [(ngModel)]="project.workload_fte"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <p class="mb-0 cursor-pointer">
              {{ "orgprojectadd.customer" | trans }}
            </p>
            <select
              (change)="setCustomer(project.customer)"
              [disabled]="step == 1 ? null : 'true'"
              id="addcustomerchoise"
              name="customer"
              [(ngModel)]="project.customer"
              class="form-control customer-control"
            >
              <option
                style="visibility: hidden !important; display: none"
                [ngValue]="'choose'"
              >
                {{ "orgprojectadd.choose" | trans }}
              </option>
              <option
                *ngFor="let customer of customerList; let i = index"
                value="{{ customer.customerId.split('_')[0] }}"
              >
                {{ customer.title }}
              </option>
            </select>
          </div>
          <div *ngIf="project.customer && dealList" class="form-group">
            <p class="mb-0 cursor-pointer">Deal</p>
            <select
              [disabled]="step == 1 ? null : 'true'"
              id="addcustomerdealchoise"
              name="deal"
              [(ngModel)]="project.dealId"
              class="form-control"
            >
              <option
                style="visibility: hidden !important; display: none"
                [ngValue]="'choose'"
                selected
              >
                {{ "orgprojectadd.choose" | trans }}
              </option>
              <option
                *ngFor="let deal of dealList; let i = index"
                value="{{ deal.dealId.split('_')[0] }}"
              >
                {{ deal.dealname }}
              </option>
            </select>
          </div>
        </form>
        <div class="row">
          <div class="col">
            <button
              type="button"
              class="close"
              (click)="openCreateCustomer()"
              class="btn w-100 float-left"
            >
              <h6 class="btn-text">
                {{ "orgprojectadd.createnewcustomer" | trans }}
              </h6>
            </button>
          </div>
          <div class="col">
            <button
              *ngIf="step == 1"
              (click)="createProject()"
              class="btn-save float-right"
              type="submit"
            >
              <h6 class="btn-save-text">
                {{ "orgprojectadd.createproject" | trans }}
              </h6>
            </button>
            <button
              *ngIf="step == 2"
              (click)="ngOnInit()"
              data-dismiss="modal"
              class="btn-close float-right"
              type="submit"
            >
              <h6 class="btn-save-text">{{ "orgprojectadd.close" | trans }}</h6>
            </button>
          </div>
        </div>
      </div>
      <app-customercreate
        *ngIf="showCustomerCreate || customerList?.length == 0"
        [fromproject]="true"
        (customerToAdd)="addCustomer($event)"
      ></app-customercreate>
    </div>
  </div>
</div>
